import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { catchError, finalize, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DeleteRecommendedRouteTechMode {
  private _http = inject(HttpClient);

  private _isLoadingDeleteRecommendedRouteTechMode = signal<boolean>(false);
  public isLoadingDeleteRecommendedRouteTechMode = this._isLoadingDeleteRecommendedRouteTechMode.asReadonly();

  private _successMessageDeleteRecommendedRouteTechMode = signal<string>('');
  public successMessageDeleteRecommendedRouteTechMode = this._successMessageDeleteRecommendedRouteTechMode.asReadonly();

  private _errorMessageDeleteRecommendedRouteTechMode = signal<string>('');
  public errorMessageDeleteRecommendedRouteTechMode = this._errorMessageDeleteRecommendedRouteTechMode.asReadonly();

  public deleteRecommendedRouteTechMode(token: string): Observable<HttpResponse<void>> {
    this._isLoadingDeleteRecommendedRouteTechMode.set(true);

    const url = `${environment.apiAssistantUrlBase}/api/recommended-route/${token}`;
    return this._http.delete<void>(url, { observe: 'response' }).pipe(
      map((response) => {
        const message = 'La ruta ha sido eliminada';
        this._successMessageDeleteRecommendedRouteTechMode.set(message);
        return response;
      }),
      catchError((error) => {
        console.error('Error deleting recommended route tech mode:', error);
        const message = 'Ha ocurrido un error al eliminar la ruta';
        this._errorMessageDeleteRecommendedRouteTechMode.set(message);
        return throwError(() => new Error('HTTP request failed', { cause: error }));
      }),
      finalize(() => {
        this._isLoadingDeleteRecommendedRouteTechMode.set(false);
      })
    );
  }
}
